.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.2rem;

  @media screen and (min-width: $bp-medium) {
    min-width: 24rem;
    gap: 0;
    border-left: 1px solid #3c404a;
    padding-left: 2.4rem;
  }
}
